import { useQuery } from "react-query";
import { PortfolioSensitivityApi } from "@iliotech/generated-api-v3";
import { API_BASE } from "../../constants/constants";

export const useApiAugmentedScenariosCoefficients = (
  portfolioId: string,
  sliderValues: {
    price: number;
    volatility: number;
    fx: number;
    yield: number;
    months: number;
  },
  enabledCondition: boolean
) => {
  const api = new PortfolioSensitivityApi(undefined, `${API_BASE}/api`);
  return useQuery(
    [`values-for-coefficients`, { portfolioId, sliderValues }],
    () =>
      api.getValues(
        portfolioId,
        sliderValues?.price,
        sliderValues?.volatility,
        sliderValues?.yield,
        sliderValues?.fx,
        undefined,
        sliderValues?.months
      ),
    {
      enabled:
        (enabledCondition &&
          !(
            sliderValues?.price === 0 &&
            sliderValues?.fx === 0 &&
            sliderValues?.volatility === 0 &&
            sliderValues?.yield === 0 &&
            sliderValues?.months === 0
          )) ??
        false,
    }
  );
};
